var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagRomania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5656 0.995125C19.8323 0.352063 17.9576 8.31859e-09 16.0004 8.31859e-09C14.0433 -6.24917e-05 12.1686 0.352063 10.4353 0.995125L9.04395 15.9999L10.4353 31.0047C12.1685 31.648 14.0433 32 16.0004 32C17.9575 32 19.8323 31.648 21.5656 31.0047L22.9569 16L21.5656 0.995125Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9999C32 9.12055 27.658 3.25574 21.5652 0.995117V31.0049C27.658 28.744 31.9999 22.8794 32 15.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 22.8796 4.342 28.7442 10.4347 31.005L10.4347 0.995361C4.342 3.25599 0 9.12061 0 16H0Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRomania);
export default __webpack_public_path__ + "static/media/flag_romania.e4e95d1877a299efbd2fb9c23dc993a1.svg";
export { ForwardRef as ReactComponent };